import axios from 'axios';
import store from '../store';
import { removeAccessToken } from '../store/authReducer';

const ApiEndpoint = localStorage.getItem('API_ENDPOINT');
const Api = axios.create({
  baseURL: `${ApiEndpoint}`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

Api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      store.dispatch(removeAccessToken());
      (window as any).location = '/access-denied'; 
    }
    return Promise.reject(error);
  }
);

export default Api;